import React, { Component } from "react";

import InputPasswordValidation from '../../../Packages/SharedComponents/Com.Gyf.WebCore.InputPasswordValidation.jsx';

class UserChangePassword extends Component {
    constructor(props) {
        super(props);
    }

    onInputPasswordChange = (event) => {
        let prop = event.target.dataset.userinfo;
        let value = event.target.value;

        if (event.statusInputPass) {
            this.props.updateInformacionUsuario(prop, value);
        }
        else {
            this.props.updateInformacionUsuario(prop, undefined);
        }
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }

    render() {
        if (this.props.configuracionPwSesion == undefined)
            return null;

        return (
            <div className="row">
                {(this.props.isEdition == true) ?
                    <div className="col-xs-8 top-separator-xxxs">
                        <div className="row">
                            <div className="col-xs-12">
                                <button className="btn btn-link" data-toggle="collapse"
                                    data-target="#nuevo-password" onClick={this.props.passWordChange}>Cambiar la clave ahora</button>
                            </div>
                        </div>

                        <div className="collapse" id="nuevo-password">
                            <div className="row">
                                <div className="col-xs-6 text-left">
                                    <label className="label-primary">Clave</label>
                                </div>
                                <div className="col-xs-6 text-right">
                                    <button className="btn-link" data-toggle="collapse"
                                        data-target="#nuevo-password" onClick={this.props.passWordUnChange}>Cancelar</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <InputPasswordValidation
                                        allowIdenticalLetters={this.props.configuracionPwSesion.PermiteLetrasConsecutivas}
                                        allowAphabeticalChars={this.props.configuracionPwSesion.Alfabetica}
                                        allowNumericChars={this.props.configuracionPwSesion.Numerica}
                                        allowSpecialChars={this.props.configuracionPwSesion.CaracteresEspeciales}
                                        allowCaseSensitiveChars={this.props.configuracionPwSesion.CaseSensitive}
                                        allowConsecutiveNumericChars={this.props.configuracionPwSesion.PermiteNrosConsecutivos}
                                        allowConsecutiveLetters={this.props.configuracionPwSesion.PermiteLetrasConsecutivas}
                                        allowRepeatPosition={this.props.configuracionPwSesion.PermiteRepetirPosicion}
                                        allowIdenticalChars={this.props.configuracionPwSesion.PermiteCaracteresIguales}
                                        minCharsAllowed={this.props.configuracionPwSesion.CaracteresMinimos}
                                        id="InputClave" data-userinfo="Clave"
                                        onParentChange={this.onInputPasswordChange}
                                        clave={this.props.clave}
                                        isEdition={this.props.isEdition} />
                                </div>
                            </div>
                        </div>
                    </div> :

                    <div className="col-xs-8 top-separator-xxs">
                        <div className="row">
                            <div className="col-xs-6 text-left">
                                <label className="label-primary">Nueva clave</label>
                            </div>
                        </div>
                        <InputPasswordValidation
                            allowAphabeticalChars={this.props.configuracionPwSesion.Alfabetica}
                            allowNumericChars={this.props.configuracionPwSesion.Numerica}
                            allowSpecialChars={this.props.configuracionPwSesion.CaracteresEspeciales}
                            allowCaseSensitiveChars={this.props.configuracionPwSesion.CaseSensitive}
                            allowConsecutiveNumericChars={this.props.configuracionPwSesion.PermiteNrosConsecutivos}
                            allowConsecutiveLetters={this.props.configuracionPwSesion.PermiteLetrasConsecutivas}
                            allowRepeatPosition={this.props.configuracionPwSesion.PermiteRepetirPosicion}
                            allowIdenticalChars={this.props.configuracionPwSesion.PermiteCaracteresIguales}
                            minCharsAllowed={this.props.configuracionPwSesion.CaracteresMinimos}
                            id="InputClave" data-userinfo="Clave"
                            onParentChange={this.onInputPasswordChange}
                            clave={this.props.clave}
                            onPaste={this.onPasteText} />
                    </div>}
            </div>
        );
    }
}

export default UserChangePassword;